<template>
  <div class="app-container">
    <el-tabs v-model="activeName" type="border-card" >
      <el-tab-pane
          v-for="item in tabList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
      >
        <keep-alive>
          <component
              :is="item.name"
              v-if="item.name === activeName"
          ></component>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import UserLoginInfo from "@/views/statisticsManagement/userStatistics/UserLoginInfo";
import UserDataStatistics from "@/views/statisticsManagement/userStatistics/UserDataStatistics";
import indexCopy from "@/views/statisticsManagement/userStatistics/indexCopy";

export default {
  name: "index",
  components: {UserDataStatistics, UserLoginInfo,indexCopy},
  data() {
    return {
      activeName: "UserLoginInfo",
      tabList: [
        {name: "UserLoginInfo", label: "用户登录统计"},
        {name: "UserDataStatistics", label: "用户活跃统计"},
        // {name: "indexCopy", label: "老版本"},
      ],
    }
  }
}
</script>

<style scoped>

</style>